module.exports = __webpack_public_path__ + "static/media/logomid.67012693.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logomid.png
// module id = 1821
// module chunks = 2